import { useMediaQuery } from '@mantine/hooks'

/**
 * Desktop-Mac breakpoint: true on the displays that leave the schedule grid with
 * unused vertical space below it, false on every laptop.
 *
 * Apple's logical ("looks like") resolutions make the split clean — the largest
 * MacBook, the 16" Pro, is 1728×1117, while the smallest desktop Mac display is
 * the 24" iMac at 2240×1260, followed by the Studio Display at 2560×1440 and the
 * Pro Display XDR at 3008×1692. 1920px therefore sits above every MacBook and
 * below every desktop Mac panel (and matches the conventional 1920×1080-and-up
 * external monitor).
 *
 * `getInitialValueInEffect: false` reads `matchMedia` during the first render so
 * the grid isn't laid out at laptop density and then re-measured a frame later.
 */
export const BIG_SCREEN_QUERY = '(min-width: 1920px)'

export const useBigScreen = (): boolean =>
  useMediaQuery(BIG_SCREEN_QUERY, false, { getInitialValueInEffect: false })
